import React, { useState } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AddRowTable from '../../Components/Table/AddRowTable';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';


import { 
    Layout,
    Col, 
    Row,
    Button,
    InputNumber,
    Checkbox,
    Upload,
    Form,
    Select,
    Input,
    DatePicker,
    Divider,
    Modal,
} from 'antd'
import { 
    ExclamationCircleFilled, 
    InboxOutlined 
} from '@ant-design/icons';
// import { formatYMD } from '../../Utils/Common';
import { useNavigate, useParams } from 'react-router-dom';
import { usePostRequest } from '../../hooks/usePostRequest'
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { formatDate } from '../../Utils/Common';

const { confirm } = Modal;
const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

const RenewTenants = () => {
    const [renewTenantForm] = Form.useForm();
    const { id } = useParams();
    const navigate = useNavigate()
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [leaseTerm, setLeaseTerm] = useState('')
    const [leaseType, setLeaseType] = useState('')
    const [isDisabled, setIsDisabled] = useState(true);
    const [contractDate, setContractDate] = useState([])
    const [propertyId, setPropertyId] = useState('')
    const [authorizedSignatories, setAuthorizedSignatories] = useState([]);
    const [authorizedRepresentative, setAuthorizedRepresentative] = useState([]);
    const [propertyData, setPropertyData] = useState([])
    const [rentalData, setRentalData] = useState([])
    const [endContractData, setEndContractDate] = useState('')

    const { callPost, data, loading } = usePostRequest(()=>{
        renewTenantForm.resetFields();
    });
    
    const values = Form.useWatch([], renewTenantForm);

    React.useEffect(() => {
        renewTenantForm.validateFields({
        validateOnly: true,
        }).then(() => {
        setIsDisabled(false);
        },
        () => {
        setIsDisabled(true);
        },
        );
    }, [values, renewTenantForm]);
    
    React.useEffect(() => {
        if (data) {
            navigate('/tenant');
        }
    }, [data, navigate]);

    React.useEffect(() => {
        fetchPropertyData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        fetchRentalData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propertyId]);

    React.useEffect(() => {
        fetchTenantData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleProperty = (e) => {
        setPropertyId(e)
    }

    const handleRentalUnit = (rental_id) => {
        const rent = rentalData.filter((item) => item.id === rental_id);
        if(rent[0]?.pricing_type === "unit"){
            renewTenantForm.setFieldsValue({
                space_rental_rate: rent[0].unit_price
            });
        }
    }

    async function fetchPropertyData() {

        const response = await UseGetRequest("properties/get", {property_id: ''});
        if (response?.data) {
          setPropertyData(response?.data?.data);
        } else {
          setPropertyData([])
        }
    
    }

    const fileUrlFormat = (files) => {
        if(files){
          return files?.map(file => ({
            uid: file.id,
            name: file.file_name,
            status: "done",
            url: file.file_url,
            fileType: file.file_type
          }));
        }
    };

    async function fetchTenantData() {
       
        const response = await UseGetRequest("tenants/get", {tenant_id: id});

        if (response?.data) {
            const tenant_data = response?.data?.data[0]
            setAuthorizedSignatories(tenant_data?.signatories);    
            setAuthorizedRepresentative(tenant_data?.representatives);    
            setAttachmentsData(fileUrlFormat(tenant_data?.attachments))
            renewTenantForm.setFieldsValue({
                alfresco_rental_rate: tenant_data.alfresco_rental_rate,
                require_or: tenant_data.require_or === "1" ? true : false,
                business_address: tenant_data.business_address,
                business_name: tenant_data.business_name,
                business_nature: tenant_data.business_nature,
                contact_no: tenant_data.contact_no,
                contract_date: [
                    dayjs(tenant_data.contract_end_date).add(1, 'day'),
                    dayjs(tenant_data.contract_end_date).add(tenant_data.lease_term, tenant_data.lease_type),
                ],
                cusa_rental_rate: tenant_data.cusa_rental_rate,
                lease_term: tenant_data.lease_term,
                lease_type: tenant_data.lease_type,
                property: tenant_data.property_name,
                remarks: tenant_data.remarks,
                rental_unit_id: tenant_data.rental_unit_id,
                renter_email: tenant_data.renter_email,
                space_rental_rate: tenant_data.space_rental_rate,
                start_date: dayjs(tenant_data.start_date),
                tin: tenant_data.tin,
                trade_name: tenant_data.trade_name,
            });
            setContractDate([
                dayjs(tenant_data.contract_end_date).add(1, 'day'),
                dayjs(tenant_data.contract_end_date).add(tenant_data.lease_term, tenant_data.lease_type),
            ])
            setLeaseTerm(tenant_data.lease_term)
            setLeaseType(tenant_data.lease_type)
            setEndContractDate(dayjs(tenant_data.contract_end_date).add(1, 'day'))
        }
    }

    async function fetchRentalData() {

        const response = await UseGetRequest("rental_units/get", {property_id: propertyId});
        if (response?.data) {
          setRentalData(response?.data?.data);
        } else {
          setRentalData([])
        }
    
    }
   
    const handleEditTenant = () => {
        renewTenantForm.validateFields().then(values => {
            const resetData = {
                tenant_id: id,
                alfresco_rental_rate: values.alfresco_rental_rate,
                business_address: values.business_address,
                business_name: values.business_name,
                business_nature: values.business_nature,
                contact_no: values.contact_no,
                contract_sign_date: values.contract_date[0].format("YYYY-MM-DD"),
                contract_end_date: values.contract_date[1].format("YYYY-MM-DD"),
                cusa_rental_rate: values.cusa_rental_rate,
                // attachments: values.attachments,
                lease_term: values.lease_term,
                lease_type: values.lease_type,
                property: values.property,
                remarks: values.remarks,
                rental_unit_id: values.rental_unit_id,
                renter_email: values.renter_email,
                space_rental_rate: values.space_rental_rate,
                start_date: values.start_date ? values.start_date.format("YYYY-MM-DD") : '',
                tin: values.tin,
                trade_name: values.trade_name,
            };

            resetData.signatory_name = authorizedSignatories.map((item)=>item.signatory_name || "")
            resetData.signatory_position = authorizedSignatories.map((item)=>item.signatory_position || "")

            resetData.representative_name = authorizedRepresentative.map((item)=>item.representative_name || "")
            resetData.representative_position = authorizedRepresentative.map((item)=>item.representative_position || "")
            resetData.representative_email = authorizedRepresentative.map((item)=>item.representative_email || "")
            resetData.representative_contact_no = authorizedRepresentative.map((item)=>item.representative_contact_no || "")

            const file = attachmentsData
            .filter(data => data.originFileObj)
            .map(data => data.originFileObj);
            
            const attch_ids = attachmentsData
            .filter(data => data.id)
            .map(data => data.id);
            
            var finalValues = Object.entries({...resetData, attachments: file, attachment_ids: attch_ids }).map(([key, value]) => ({
                key,
                value,
            }));


            callPost(
                "tenants/renew", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed:', errorInfo);
        });
    };

    const handleDeleteAttachment = (file) => {
        const updatedAttachments = attachmentsData.filter(item => item !== file);
        setAttachmentsData(updatedAttachments);
    };
    const normFile = (e) => {

        if (Array.isArray(e)) {
            setAttachmentsData(e)
        }
        setAttachmentsData(e?.fileList)
        
    };

    const validateContactNumber = (_, value) => {
        if (!value) {
          return Promise.resolve();
        }
    
        const isNumber = /^\d+$/.test(value);
        if (!isNumber) {
          return Promise.reject('Invalid Contact Number');
        }
        return Promise.resolve();
    };

    const onLeaseChange = (value) => {
        if (value) {
            setLeaseTerm(value)
            renewTenantForm.setFieldsValue({
                contract_date: [
                    dayjs(endContractData, 'YYYY/MM/DD'),
                    dayjs(endContractData, 'YYYY/MM/DD').add(value, leaseType).subtract(1, 'day')
                ]
            });
            setContractDate([
                dayjs(endContractData, 'YYYY/MM/DD'),
                dayjs(endContractData, 'YYYY/MM/DD').add(value, leaseType).subtract(1, 'day')
            ])
           
        }
    }
    const handleRangeChange = (dates) => {
        if (dates && dates.length > 0) {
            // If dates is not null and has at least one element
            // Update start date
            renewTenantForm.setFieldsValue({
                contract_date: [
                    dayjs(dates[0], 'YYYY/MM/DD'),
                    dayjs(dates[0], 'YYYY/MM/DD').add(leaseTerm, 'year').subtract(1, 'day')
                ]
            });
            setEndContractDate(dayjs(dates[0], 'YYYY/MM/DD'))
            setContractDate([
                dayjs(dates[0], 'YYYY/MM/DD'),
                dayjs(dates[0], 'YYYY/MM/DD').add(leaseTerm, 'year').subtract(1, 'day')
            ])
        }
    };
    const showSaveConfirm = () => {
        confirm({
          title: 'Please review Lease Term and Contract Date',
          icon: <ExclamationCircleFilled style={{ color: 'yellow' }}/>,
        //   content: `Lease Term: ${leaseTerm} , Contract Date: ${formatDate(contractDate[0].format("YYYY-MM-DD"))} - ${formatDate(contractDate[1].format("YYYY-MM-DD"))}`,
          content: (
            <div>
              <div>Lease Term: {leaseTerm} {leaseType}</div>
              <div>Contract Date: {formatDate(contractDate[0].format("YYYY-MM-DD"))} - {formatDate(contractDate[1].format("YYYY-MM-DD"))}</div>
            </div>
          ),
          okText: 'Yes',
        //   okType: 'danger',
          cancelText: 'No',
          className: 'custom-modal',
          confirmLoading: loading,
          onOk() {
            handleEditTenant()
          },
        });
    };
    return (
        <Layout className='page'>
            <Navbar/>
            <Layout className='content-container overflow-y'>
                <Row>
                    <Col span={24} className='header-container p-4'>
                        RENEW RENTER INFO
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='p-4'>
                        <Form form={renewTenantForm} initialValues={{ lease_type: leaseType }} layout="vertical">
                            <Divider className='divider-text'>Renter Information</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="Name"
                                        name="trade_name"
                                        rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <Input disabled/>
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Business Name"
                                        name="business_name"
                                        // rules={[{ required: true, message: 'Please enter your confirm Business Name!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Business Address"
                                        name="business_address"
                                        rules={[{ required: true, message: 'Please enter your confirm Business Address!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="TIN Number"
                                        name="tin"
                                        // rules={[{ required: true, message: 'Please enter your Tin!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Renter Email"
                                        name="renter_email"
                                        rules={[{ required: true, message: 'Please enter your Renter Email!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Contact Number"
                                        name="contact_no"
                                        rules={
                                            [
                                                { 
                                                    required: true, message: 'Please enter your Contact Number!' 
                                                },
                                                {
                                                    validator: validateContactNumber
                                                },
                                            ]
                                        }
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={12}>
                                    <Item
                                        label="Nature of Renter"
                                        name="business_nature"
                                        // rules={[{ required: true, message: 'Please enter your confirm Contact Person!' }]}
                                    >
                                        <TextArea rows={3}/>
                                    </Item>
                                </Col>
                                <Col span={12}>
                                    <Item
                                        label="Remarks"
                                        name="remarks"
                                    >
                                        <TextArea rows={3}/>
                                    </Item>
                                </Col>
                            </Row>
                            <Divider className='divider-text mt-5'>Contract Detail</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="Property/Building"
                                        name="property"
                                        rules={[{ required: true, message: 'Please select your Property' }]} // Adjusted message
                                    >
                                        <Select placeholder="Select a property" onChange={(e) => handleProperty(e)}>
                                            {propertyData.map((option) => (
                                                <Option key={option.id} value={option.id}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Unit Number"
                                        name="rental_unit_id"
                                        rules={[{ required: true, message: 'Please select your Rental Unit' }]} // Adjusted message
                                    >
                                        <Select placeholder="Select a Rental Unit" onChange={(e) => handleRentalUnit(e)}>
                                            {rentalData.map((option) => (
                                                <Option key={option.id} value={option.id}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={8} className='center pt-4'>
                                    <Item name="require_or" valuePropName="checked">
                                        <Checkbox>OR Required upon Payment</Checkbox>
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={4}>
                                    <Item
                                        label="Lease Type"
                                        name="lease_type"
                                        rules={[{ required: true, message: 'Please select your Lease Type' }]} // Adjusted message
                                    >
                                        <Select 
                                            placeholder="Select a Lease Type"
                                            // onChange={(e) => onLeaseType(e)}
                                            // defaultValue={leaseType} 
                                            disabled
                                        >
                                            {/* <Option key='daily' value='daily'>Daily</Option> */}
                                            <Option key='month' value='month'>Monthly</Option>
                                            <Option key='year' value='year'>Yearly</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={4}>
                                    <Item
                                        label="Lease Term"
                                        name="lease_term"
                                        rules={[{ required: true, message: 'Please enter your Lease Term!' }]}
                                    >
                                        <InputNumber 
                                            min={0}
                                            style={{width:'100%'}}
                                            onChange={(e) => onLeaseChange(e)}
                                        />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item 
                                        name="contract_date"  
                                        label="Contract Date"
                                        rules={[{ required: true, message: 'Please enter your Signed Contract Date!' }]}
                                    >
                                        <RangePicker  
                                            style={{width:'100%'}}
                                            disabled={true}
                                            onChange={handleRangeChange}
                                        />
                                    </Form.Item>
                                </Col>
                                {/* <Col span={8}>
                                    <Item
                                        label="Move In Date"
                                        name="start_date"
                                        rules={[{ required: true, message: 'Please enter your Commencement of Lease!' }]}
                                    >
                                        <DatePicker style={{width:'100%'}} format="YYYY-MM-DD"/>
                                    </Item>
                                </Col> */}
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={4}>
                                    <Item
                                        label="Rental Rate"
                                        name="space_rental_rate"
                                        rules={[{ required: true, message: 'Please enter your Space Rental Rate!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={4}>
                                    <Item
                                        label="Cusa Rental Rate"
                                        name="cusa_rental_rate"
                                        // rules={[{ required: true, message: 'Please enter your Cusa Rental Rate!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={4}>
                                    <Item
                                        label="Alfresco Rental Rate"
                                        name="alfresco_rental_rate"
                                        // rules={[{ required: true, message: 'Please enter your Alfresco Rental Rate!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                            </Row>
                            <Divider className='divider-text'>Authorizations</Divider>
                            <Row>
                                <Col span={24} className='p-2'>
                                    Authorized Signatories
                                </Col>
                            </Row>
                            <Row className='responsive-overflow-y'>
                                <Col span={24} className='p-2'>
                                    <AddRowTable
                                        tableHeaders={[
                                        "Name",
                                        "Position",
                                        ]}
                                        headerSelector={[
                                        "signatory_name",
                                        "signatory_position",
                                        ]}
                                        withAction={true}
                                        withRender={false}
                                        withAddRow={true}
                                        isDisabled={isDisabled}
                                        setDataSource={setAuthorizedSignatories}
                                        dataSource={authorizedSignatories}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='p-2'>
                                    Local Authorized Representatives
                                </Col>
                            </Row>
                            <Row className='responsive-overflow-y'> 
                                <Col span={24} className='p-2'>
                                
                                <AddRowTable
                                    tableHeaders={[
                                    "Name",
                                    "Position",
                                    "Email",
                                    "Mobile Number",
                                    ]}
                                    headerSelector={[
                                    "representative_name",
                                    "representative_position",
                                    "representative_email",
                                    "representative_contact_no",
                                    ]}
                                    withAction={true}
                                    withRender={false}
                                    withAddRow={true}
                                    isDisabled={isDisabled}
                                    setDataSource={setAuthorizedRepresentative}
                                    dataSource={authorizedRepresentative}
                                />
                            
                                </Col>
                            </Row>                   
                            <Row className='responsive-inline responsive-width'>
                                <Col span={24} className='p-2'>
                                    <Item 
                                        label="Attachment"
                                        name="attachments" 
                                        // valuePropName="fileList" 
                                        getValueFromEvent={normFile} 
                                        noStyle
                                        >
                                        <Upload.Dragger 
                                            multiple
                                            name="files" 
                                            // action="/upload.do"
                                            fileList={attachmentsData}               
                                            beforeUpload={() => false}
                                            onRemove={handleDeleteAttachment}
                                        >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                                        </Upload.Dragger>
                                    </Item>
                                </Col>
                            </Row>
                            <Row className='btn-footer'>
                                <Col span={2} className='p-2'>
                                    <Button
                                        onClick={() => navigate('/tenant')}
                                        className='cancel-color btn-header'
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                                <Col span={2} className='p-2'>
                                    <Button
                                        onClick={showSaveConfirm}
                                        type='primary'
                                        loading={loading}
                                        className='button-color btn-header'
                                        disabled={isDisabled}
                                    >
                                        Save
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default RenewTenants
